import { zodResolver } from "@hookform/resolvers/zod";
import { useInvestorUpdate } from "gen/endpoints/investor/investor";
import { InvestorEditDataRequest } from "gen/model/investorEditDataRequest";
import { InvestorReadData } from "gen/model/investorReadData";
import { investorUpdateBody } from "gen/schemas/investor/investor";
import { useCallback } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormProps } from "shared/components/form/Form";
import { FormTextInput } from "shared/components/input/text/TextInput";

export const InvestorFormFields: React.FC = () => {
  const { t } = useTranslation(["investor"]);
  return (
    <>
      <FormTextInput name="name" title={t("investor:name")} />
      <FormTextInput
        name="primary_contact_email"
        title={t("investor:primaryContactEmail")}
      />
    </>
  );
};

export interface InvestorEditFormProps {
  investor: InvestorReadData;
}

export const useInvestorEditForm = ({
  investor,
}: InvestorEditFormProps): FormProps<
  InvestorEditDataRequest,
  InvestorEditDataRequest
> => {
  const { t } = useTranslation(["investor"]);

  const { mutateAsync: editInvestor } = useInvestorUpdate();

  const onSubmit = useCallback(
    (data: InvestorEditDataRequest) =>
      editInvestor({
        investorId: investor.id,
        data,
      }),
    [editInvestor, investor.id],
  );

  const form = useForm<InvestorEditDataRequest>({
    resolver: zodResolver(investorUpdateBody),
    defaultValues: investor,
  });

  return {
    form,
    onSubmit,
    successMessage: t("investor:edit.success"),
  };
};
